import { FormattedMessage } from 'react-intl';
import { LottiePlayer } from '@repo/design-system-kit';
import hourglassLottie from '@repo/visual-assets/dotlottie/lottie_cp_general_hourglass.lottie';
import type { ReactNode } from 'react';
import { Container } from '#customer-registration/business-account/index.ts';
import styles from './pending-contract.module.css';

interface PendingContractProps {
  className?: string;
  isEmbedQf?: boolean;
}

export function PendingContract({ className, isEmbedQf }: PendingContractProps) {
  return (
    <Container>
      <div className={`${styles.container} ${className ?? ''}`}>
        <LottiePlayer
          autoplay
          className={`${styles.illustration} mb-32`}
          loop
          src={hourglassLottie}
        />
        <h1 className={`${styles.title} heading-page mb-16`}>
          <FormattedMessage id="customer-registration-kit.pending-contract-sign.title" />
        </h1>
        <p className={`${styles.subtitle} body-prominent`}>
          <FormattedMessage
            id={
              isEmbedQf
                ? 'customer-registration-kit.pending-contract-sign.subtitle-embed'
                : 'customer-registration-kit.pending-contract-sign.subtitle'
            }
            values={{
              link: (chunks: ReactNode) => <a href="mailto:support@qonto.com">{chunks}</a>,
            }}
          />
        </p>
      </div>
    </Container>
  );
}
